import { render, staticRenderFns } from "./Uz.vue?vue&type=template&id=12a37a36&"
import script from "./Uz.vue?vue&type=script&lang=js&"
export * from "./Uz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports